import { render, staticRenderFns } from "./WidgetSunDivLayout.vue?vue&type=template&id=0ca2a4e2&scoped=true&"
import script from "./WidgetSunDivLayout.vue?vue&type=script&lang=js&"
export * from "./WidgetSunDivLayout.vue?vue&type=script&lang=js&"
import style0 from "./WidgetSunDivLayout.vue?vue&type=style&index=0&id=0ca2a4e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca2a4e2",
  null
  
)

export default component.exports